import { StandardEvents } from '@shopify/events';

const FLOATING_CART_SELECTOR = '[data-ks-floating-cart]';
const HEADER_COUNT_SELECTOR = '[data-testid="cart-bubble"]';

/**
 * Mirrors Shopify's authoritative cart quantity to every floating cart trigger.
 * @param {number} itemCount
 */
function updateFloatingCart(itemCount) {
  const count = Math.max(0, Number(itemCount) || 0);
  const label = count === 1 ? 'item' : 'items';

  document.querySelectorAll(FLOATING_CART_SELECTOR).forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;

    const countElement = button.querySelector('.ks-floating-cart__count');
    if (countElement) countElement.textContent = count > 99 ? '99+' : String(count);

    button.hidden = count === 0;
    button.dataset.cartCount = String(count);
    button.setAttribute('aria-label', `Open cart, ${count} ${label}`);
  });
}

/**
 * Uses the working header cart bubble as a secondary source for page restore
 * and for third-party cart changes that update the header directly.
 */
function syncFromHeader() {
  const headerCount = document.querySelector(HEADER_COUNT_SELECTOR)?.textContent?.trim();
  if (headerCount === undefined || headerCount === '') return;

  const count = Number.parseInt(headerCount, 10);
  if (Number.isFinite(count)) updateFloatingCart(count);
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      const itemCount = cart?.totalQuantity ?? detail?.itemCount;
      if (Number.isFinite(Number(itemCount))) updateFloatingCart(Number(itemCount));
    })
    .catch(() => {
      syncFromHeader();
    });
});

const headerCartIcon = document.querySelector('cart-icon');
if (headerCartIcon) {
  new MutationObserver(syncFromHeader).observe(headerCartIcon, {
    childList: true,
    characterData: true,
    subtree: true,
  });
}

window.addEventListener('pageshow', syncFromHeader);
syncFromHeader();
